import allComponentsDefinitionsMap from '../../dist/schemas/componentsDefinitionsMap.json'
import allFullyRestrictedNonInflatedSchemas from '../../dist/allFullyRestrictedNonInflatedSchemas.json'
import * as schemaArrangement from '../schemaArrangement'

const restrictedNonInflatedSchemas = schemaArrangement.arrangeByDataTypeAndConvertSchemaNamesToOldStyleFileNames(
    allFullyRestrictedNonInflatedSchemas,
    true
)

export default {
    allComponentsDefinitionsMap,
    componentsDefinitionsMap: allComponentsDefinitionsMap,
    restrictedNonInflatedSchemas
}
